import * as o from "react";
import e from "../lib/IconBase.es.js";
import t from "../defs/BookBookmark.es.js";
const r = o.forwardRef((a, m) => /* @__PURE__ */ o.createElement(e, { ref: m, ...a, weights: t }));
r.displayName = "BookBookmarkIcon";
const s = r;
export {
  s as BookBookmark,
  r as BookBookmarkIcon
};
